import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import parseUnit from 'parse-unit';

// Register ScrollTrigger plugin
gsap.registerPlugin(ScrollTrigger);

const ATTR_PARALLAX_CHILD = 'op-parallax-child';

export default class parallax {
  constructor(element) {
    this.element = element;
    this.children = [];
    
    this._init();
  }

  // Initialize the parallax effect
  _init() {
    this._collectChildren();
    this._applyParallax();
  }

  // Collect all child elements with 'op-parallax-child' attributes
  _collectChildren() {
    const childNodes = Array.from(this.element.children).filter(child =>
      child.hasAttribute(ATTR_PARALLAX_CHILD)
    );

    this.children = childNodes.map(childNode => new ParallaxItem(childNode));
  }

  // Apply parallax effect using GSAP
  _applyParallax() {
    this.children.forEach(child => {
      const settings = child.settings;
      
      // Set up ScrollTrigger for each child element
      gsap.fromTo(child.el, {
        // opacity: 0,
        y: settings.y[0],  // Initial position based on settings
        // x: settings.x.from,
        // scale: settings.scale.from
      }, {
        // opacity: 1,
        y: settings.y[1],  // Final position based on settings
        // x: settings.x.to,
        // scale: settings.scale.to,
        scrollTrigger: {
          trigger: child.el,
          start: 'top bottom',  // Trigger when the element enters the viewport
          end: 'bottom top',    // End when the element leaves the viewport
          scrub: true,           // Smooth scroll effect
          toggleActions: "play none none reverse",
          markers: false,       // Optionally enable markers to debug scroll positions
        }
      });
    });
  }
}

// Parallax Item Class to store settings and manage animation
class ParallaxItem {
  constructor(el) {
    this.el = el;
    this.settings = this._getSettings(el);  // Safely get settings

    // Ensure settings exist, fallback to defaults if not
    this.y = this._processValue(this.settings?.y);
    this.x = this._processValue(this.settings?.x);
    this.opacity = this._processValue(this.settings?.opacity);
    this.scale = this._processValue(this.settings?.scale);
  }

  // Helper function to safely parse settings from attribute
  _getSettings(el) {
    const settings = el.getAttribute(ATTR_PARALLAX_CHILD);
    try {
      return settings ? JSON.parse(settings) : {};  // Return empty object if no settings
    } catch (e) {
      console.error('Invalid JSON in op-parallax-child attribute', e);
      return {};  // Return empty object if JSON parsing fails
    }
  }

  // Helper function to process value with unit and provide a fallback
  _processValue(value) {
    if (!value) return { from: 0, to: 0 };  // Fallback to { from: 0, to: 0 }

    // Ensure both `from` and `to` values are valid numbers or fallback to defaults
    const [from, to] = value.map(val => {
      const parsedValue = parseUnit(val);
      return parsedValue[0] !== undefined ? parsedValue[0] : 0;  // Fallback to 0 if undefined
    });

    return { from, to };
  }
}